import React, { ReactElement, useEffect, useState } from 'react';
import { TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainerStyled } from './mapStyles';
import 'leaflet-polylinedecorator';
import { useIonViewDidEnter } from '@ionic/react';
import { AONB_Bounds } from '../../application/config';
import LocationMarker from '../Mapping/LocationMarker';
import TrailMarkers from '../Mapping/TrailMarkers';
import TrailsMapController from '../Mapping/TrailsMapController';
import { Trail } from '../../models/Trail';

type MapProps = {
	trails: Trail[];
	activeIndex: number;
	isVisible: boolean;
};

function TrailsMap({ trails, activeIndex, isVisible }: MapProps): ReactElement {
	const [currentIndex, setCurrentIndex] = useState(activeIndex);
	useIonViewDidEnter(() => {
		window.dispatchEvent(new Event('resize'));
	});

	useEffect(() => {
		setCurrentIndex(activeIndex);
	}, [activeIndex]);

	return (
		<>
			<MapContainerStyled
				id="globalMap"
				className="fullMap"
				center={AONB_Bounds.getCenter()}
				zoom={14}
				scrollWheelZoom={true}
				attributionControl={false}>
				<>
					<TrailsMapController trails={trails} isVisible={isVisible} />
					<TileLayer
						attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					<LocationMarker />
					<TrailMarkers
						key={`place-trails`}
						trails={trails}
						activeIndex={currentIndex}
					/>
				</>
			</MapContainerStyled>
		</>
	);
}

export default TrailsMap;
